export default __webpack_public_path__ + "static/media/semaphore.c797296c.png";